export const ARTICLE_LIKE_REQUEST = 'ARTICLE_LIKE_REQUEST';
export const ARTICLE_LIKE_REQUEST_SUCCESS = 'ARTICLE_LIKE_REQUEST_SUCCESS';
export const ARTICLE_LIKE_REQUEST_FAILURE = 'ARTICLE_LIKE_REQUEST_FAILURE';

export const ARTICLE_LIKE_CREATE_REQUEST = 'ARTICLE_LIKE_CREATE_REQUEST';
export const ARTICLE_LIKE_CREATE_REQUEST_SUCCESS = 'ARTICLE_LIKE_CREATE_REQUEST_SUCCESS';

export const ARTICLE_LIKE_DELETE_REQUEST = 'ARTICLE_LIKE_DELETE_REQUEST';
export const ARTICLE_LIKE_DELETE_REQUEST_SUCCESS = 'ARTICLE_LIKE_DELETE_REQUEST_SUCCESS';
